(function ($, Global) {
    function formatUrl(url) {
        if (url.startsWith('/')) {
            var language = $('meta[name="PublicationLanguage"]').attr('content');
            var startUrl = "/"  + language
            if (language && !url.startsWith(startUrl + "/"))
                url = startUrl + url;
        }
        return url;
    }

	$.ajaxGet = function (url, data) {
        return $.ajaxGetWithTimeout(url, data, 25000);
    };

    $.ajaxGetWithTimeout = function (url, data,timeout) {
        return $.ajax({
            type: 'GET',
            url: formatUrl(url),
            contentType: 'application/json',
            data: data,
            timeout: timeout
        }).fail(function (jqXHR, textStatus) {
            var msg = $('#ajaxErrorTimeout').text();

            $('.loading').removeClass('loading');
            $('.loading-search').removeClass('loading-search');
            $.Topic('show-message').publish(msg, 'error');
        });
    };
}(jQuery, window));